import { defineTable } from "convex/server";
import { v, type Infer } from "convex/values";

export const CURRENCIES = {
  USD: "usd",
  EUR: "eur",
} as const;

export const currencyValidator = v.union(
  v.literal(CURRENCIES.USD),
  v.literal(CURRENCIES.EUR),
);

export type Currency = Infer<typeof currencyValidator>;

export const INTERVALS = {
  MONTH: "month",
  YEAR: "year",
} as const;

export const intervalValidator = v.union(
  v.literal(INTERVALS.MONTH),
  v.literal(INTERVALS.YEAR),
);

export type Interval = Infer<typeof intervalValidator>;

export const PLANS = {
  FREE: "free",
  PRO: "pro",
} as const;

export const planKeyValidator = v.union(
  v.literal(PLANS.FREE),
  v.literal(PLANS.PRO),
);

export type PlanKey = Infer<typeof planKeyValidator>;

const priceValidator = v.object({
  stripeId: v.string(),
  amount: v.number(),
});

const pricesValidator = v.object({
  [CURRENCIES.USD]: priceValidator,
  [CURRENCIES.EUR]: priceValidator,
});

/**
 * Subscription plan definitions synced from Stripe.
 */
export const plansTable = defineTable({
  key: planKeyValidator,
  stripeId: v.string(),
  name: v.string(),
  description: v.string(),
  prices: v.object({
    [INTERVALS.MONTH]: pricesValidator,
    [INTERVALS.YEAR]: pricesValidator,
  }),
})
  .index("key", ["key"])
  .index("stripeId", ["stripeId"]);

export type PlanFields = Infer<typeof plansTable.validator>;
